import axios from 'axios'
import store from '../state/store'

// The rail section toggle is a personal UI preference, persisted in
// localStorage. The URL stays focused on the loaded entity (e/l/t/lpt).
const MAIN_VIEW_KEY = 'main_view'

store.on('ui:main_view:set', function(view) {
  // Clicking a rail icon always lands on that section's "list" — sub-view
  // state (pipeline_view / tasks_view) is reset here. The currently loaded
  // enquiry/lead is untouched, so flipping back into the work section (or
  // re-selecting a row) brings it straight back.
  let next = { main_view: view }
  if (view === 'pipeline') next = { main_view: view, pipeline_view: 'table' }
  if (view === 'tasks')    next = { main_view: view, tasks_view: 'list' }

  store.get().ui.set(next)
  try { localStorage.setItem(MAIN_VIEW_KEY, view) } catch (e) { /* ignore */ }

  if (view === 'pipeline' && !store.get().pipeline.loaded) {
    store.emit('pipeline:index')
  }
})

store.on('ui:main_view:toggle', function() {
  const next = store.get().ui.main_view === 'pipeline' ? 'backlog' : 'pipeline'
  store.emit('ui:main_view:set', next)
})

const requestParams = (p, offset) => {
  const params = {
    manager_id: p.manager_id == null ? '' : p.manager_id,
    coordinator_id: p.coordinator_id == null ? '' : p.coordinator_id,
    include_unclaimed: p.include_unclaimed ? 'true' : 'false',
    include_archived: p.include_archived ? 'true' : 'false',
    offset: offset,
    per_page: p.per_page,
    column: p.current_tab || ''
  }
  if (p.terminal_from) params.terminal_from = p.terminal_from
  if (p.terminal_to)   params.terminal_to   = p.terminal_to
  return params
}

store.on('pipeline:index', function() {
  const p = store.get().pipeline

  store.get().pipeline.set({ loading: true, loading_more: false, journeys: [], offset: 0, has_more: false })

  axios.get('/api/sales/journeys', { params: requestParams(p, 0) })
    .then((response) => {
      store.get().pipeline.set({
        loading: false,
        loaded: true,
        assignment_required: response.data.assignment_required === true,
        terminal_counts_available: response.data.terminal_counts_available === true,
        journeys: response.data.journeys,
        stage_columns: response.data.stage_columns,
        stage_counts: response.data.stage_counts || {},
        manager_options: response.data.manager_options,
        manager_id: response.data.manager_id,
        coordinator_options: response.data.coordinator_options,
        coordinator_id: response.data.coordinator_id,
        terminal_from: response.data.terminal_from || null,
        terminal_to: response.data.terminal_to || null,
        offset: response.data.offset,
        per_page: response.data.per_page,
        has_more: response.data.has_more === true
      })
    })
    .catch(window.handleError)
})

store.on('pipeline:load_more', function() {
  const p = store.get().pipeline
  if (p.loading || p.loading_more || !p.has_more) return

  const next_offset = p.offset + p.per_page
  store.get().pipeline.set({ loading_more: true })

  axios.get('/api/sales/journeys', { params: requestParams(p, next_offset) })
    .then((response) => {
      const existing_keys = new Set(store.get().pipeline.journeys.map((r) => r.journey_key))
      const fresh = response.data.journeys.filter((r) => !existing_keys.has(r.journey_key))

      store.get().pipeline.set({
        loading_more: false,
        journeys: store.get().pipeline.journeys.concat(fresh),
        offset: response.data.offset,
        has_more: response.data.has_more === true
      })
    })
    .catch((err) => {
      store.get().pipeline.set({ loading_more: false })
      window.handleError(err)
    })
})

store.on('pipeline:filter:manager', function(manager_id) {
  store.get().pipeline.set({ manager_id })
  store.emit('pipeline:index')
})

store.on('pipeline:filter:coordinator', function(coordinator_id) {
  store.get().pipeline.set({ coordinator_id })
  store.emit('pipeline:index')
})

store.on('pipeline:filter:include_unclaimed', function(value) {
  store.get().pipeline.set({ include_unclaimed: value })
  store.emit('pipeline:index')
})

store.on('pipeline:filter:include_archived', function(value) {
  store.get().pipeline.set({ include_archived: value })
  store.emit('pipeline:index')
})

// Date-range filter applied to terminal columns (Closed, Handed Over). The
// payload is `{ from, to }`; either may be null to leave unchanged.
store.on('pipeline:filter:terminal_range', function({ from, to } = {}) {
  const updates = {}
  if (from !== undefined) updates.terminal_from = from
  if (to !== undefined)   updates.terminal_to   = to
  if (Object.keys(updates).length === 0) return
  store.get().pipeline.set(updates)
  store.emit('pipeline:index')
})

store.on('pipeline:tab', function(column_key) {
  if (store.get().pipeline.current_tab === column_key) return
  store.get().pipeline.set({ current_tab: column_key })
  store.emit('pipeline:index')
})

store.on('pipeline:row:open', function(row) {
  if (row.source_type === 'Sales::Lead') {
    store.emit('leads:show', row.source_id)
  } else {
    // Land on the Overview tab when arriving from the journeys grid — that
    // view summarises where the enquiry is in its journey.
    store.emit('enquiries:show', row.source_id, 'overview')
  }
  // Stay in the pipeline section but switch to detail mode so the loaded
  // enquiry/lead takes the main area. Clicking the grid icon flips it back.
  store.get().ui.set({ pipeline_view: 'detail' })
})
